export enum ApplicationLanguages {
  ENGLISH=1,
  FRENCH=2,
}

export enum VideoLanguages{
  English=1,
  French=2,
  CanadianFrench=3,
  Punjabi=4,
  ChineseSimplified=5,
  Arabic=6,
  Persian=7,
  ChineseTraditional=8
}


